import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './feature/Header';
import { Footer } from './feature/Footer';
import { PortalProvider } from '../pages/home/PortalContext';

export const PublicLayout: React.FC = () => {
  // The per-UDA accent is applied app-wide on :root at startup (see main.tsx),
  // so every page on a UDA subdomain inherits it.
  //
  // PortalProvider wraps these pages so the Header can name the UDA whose site is
  // actually being viewed. Only the home page used to provide it, so on /about,
  // /services, /rti and friends the header fell back to the DTCP wordmark even on
  // a UDA subdomain.
  return (
    <PortalProvider>
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </PortalProvider>
  );
};
